import React, { memo } from 'react'

import CustomDialog from '../shared/customDialog/CustomDialog'
import HeadingText from '../shared/text/HeadingText'

const SuccessPopup = ({ t, onSubmit, type, value }) => {
  return (
    <CustomDialog
      isForm
      title={t(`home.${type}-title`)}
      description={t(`home.${type}-desc`)}
      open
      submitProps={{
        label: t('common.close'),
        autoWidth: true
      }}
      onSubmit={onSubmit}
      t={t}
      body={value && <HeadingText label={value} isLargeFont />}
    />
  )
}

export default memo(SuccessPopup)
